module.exports = __webpack_public_path__ + "static/media/6-1.6de9d856.png";